export default function getTagDefinitions(): string[] {
  return [];
}
